export const environment = {
  production: true,
  APIURL: 'https://testing.lumia.ng/api/v2/',
  baseUrl : "https://testing.lumia.ng/api/"

};
